var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnydeskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49922 0L0 6.5L6.49922 13L12.9992 6.5L6.49922 0ZM12.2557 0.00780968L10.8117 1.4526L15.8802 6.49453L10.8117 11.563L12.2565 12.982L18.7432 6.49453L12.2557 0.00780968Z",
    fill: "#4D5874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnydeskIcon);
export default __webpack_public_path__ + "static/media/anydesk_icon.fa30bab47ddf17c2a6e1cab53944aaad.svg";
export { ForwardRef as ReactComponent };